import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import ErrorIllustration from './crash.svg?react';
import styles from './ErrorBoundary.module.css';

interface ErrorBoundaryProps {
	children: ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(): ErrorBoundaryState {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: ErrorInfo): void {
		console.error(error, info);
	}

	handleReload = () => {
		globalThis.window.location.reload();
	};

	render() {
		if (this.state.hasError) {
			return (
				<div className={styles.container}>
					<ErrorIllustration className={styles.illustration} />
					<div className={styles.textArea}>
						<h1 className={styles.title}>Algo deu errado</h1>
						<p className={styles.message}>Ocorreu um erro inesperado na aplicação.</p>
						<button className={styles.button} onClick={this.handleReload}>
							Recarregar
						</button>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}
